<template>
  <span class="bg-primary font-weight-bold text-white new-chip qtm-body-small px-1">
    NEW
  </span>
</template>
